<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="35%"
    append-to-body
    @close="handleClose"
  >
    <el-form label-width="200px" :model="editForm" ref="editForm">
      <el-row>
        <el-form-item label="应收款" prop="receivables">
          <el-input
            size="small"
            v-model="editForm.receivables"
            auto-complete="off"
            placeholder="应收款"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="应付款" prop="payable">
          <el-input
            size="small"
            v-model="editForm.payable"
            auto-complete="off"
            placeholder="应付款"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="华之瑞修农" prop="bank1">
          <el-input
            size="small"
            v-model="editForm.bank1"
            auto-complete="off"
            placeholder="华之瑞修农"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="华之瑞山西" prop="bank2">
          <el-input
            size="small"
            v-model="editForm.bank2"
            auto-complete="off"
            placeholder="华之瑞山西"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="现金" prop="bank3">
          <el-input
            size="small"
            v-model="editForm.bank3"
            auto-complete="off"
            placeholder="现金"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="华之瑞亿联" prop="bank4">
          <el-input
            size="small"
            v-model="editForm.bank4"
            auto-complete="off"
            placeholder="华之瑞亿联"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="锦乐飞沁阳0121+庄严亿联" prop="bank5">
          <el-input
            size="small"
            v-model="editForm.bank5"
            auto-complete="off"
            placeholder="锦乐飞沁阳0121+庄严亿联"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="庞钱民生" prop="bank6">
          <el-input
            size="small"
            v-model="editForm.bank6"
            auto-complete="off"
            placeholder="庞钱民生"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="王建信用社" prop="bank7">
          <el-input
            size="small"
            v-model="editForm.bank7"
            auto-complete="off"
            placeholder="王建信用社"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="少其山西2214" prop="bank8">
          <el-input
            size="small"
            v-model="editForm.bank8"
            auto-complete="off"
            placeholder="少其山西2214"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="庄严山西2381" prop="bank9">
          <el-input
            size="small"
            v-model="editForm.bank9"
            auto-complete="off"
            placeholder="庄严山西2381"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="王威兴业" prop="bank10">
          <el-input
            size="small"
            v-model="editForm.bank10"
            auto-complete="off"
            placeholder="王威兴业"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="基本户" prop="bank11">
          <el-input
            size="small"
            v-model="editForm.bank11"
            auto-complete="off"
            placeholder="基本户"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="金飞益招商" prop="bank12">
          <el-input
            size="small"
            v-model="editForm.bank12"
            auto-complete="off"
            placeholder="金飞益招商"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="少其亿联" prop="bank13">
          <el-input
            size="small"
            v-model="editForm.bank13"
            auto-complete="off"
            placeholder="少其亿联"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="麦丰亿联" prop="bank14">
          <el-input
            size="small"
            v-model="editForm.bank14"
            auto-complete="off"
            placeholder="麦丰亿联"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="乐共农商+金飞益博爱中行" prop="bank15">
          <el-input
            size="small"
            v-model="editForm.bank15"
            auto-complete="off"
            placeholder="乐共农商+金飞益博爱中行"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="其他" prop="bank16">
          <el-input
            size="small"
            v-model="editForm.bank16"
            auto-complete="off"
            placeholder="其他"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { addReconcileStream } from "@/api/ticket/ticket";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      
    };
  },
  methods: {
    handleSubmit() {
      addReconcileStream(this.editForm)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch(this.$message.warning);
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ticket/ticket-flow/add-edit/index.vue